import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  search: string;
  handleChipClick?: (chip: string) => void;
  activeChip?: string;
  chips?: string[];
};

export const SearchTable = ({
  handleChange,
  placeholder,
  search,
  chips,
  activeChip,
  handleChipClick,
}: Props) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const onChipClick = (chip: string) => {
    handleChipClick?.(chip);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && search === '' && activeChip) {
      handleChipClick?.('');
    }
  };

  return (
    <div className="relative w-full border-b border-gray-200 dark:border-gray-700 transition-all focus-within:border-blue-500">
      <div className="flex flex-wrap items-center gap-2 px-4 py-2">
        {chips && chips.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {chips.map((chip) => (
              <button
                key={chip}
                type="button"
                onClick={() => onChipClick(chip)}
                className={`px-3 py-1 rounded-full text-xs transition-colors border whitespace-nowrap ${
                  activeChip === chip
                    ? 'bg-blue-500 border-blue-500 text-white'
                    : 'bg-gray-100 border-gray-200 dark:bg-gray-800 dark:border-gray-600 text-gray-600 dark:text-gray-300'
                }`}
              >
                {t(chip)}
              </button>
            ))}
          </div>
        )}

        <input
          ref={inputRef}
          type="search"
          className="flex-grow bg-transparent py-1 outline-none min-w-[150px] dark:text-white text-sm"
          placeholder={t(placeholder)}
          onChange={(e) => handleChange(e)}
          onKeyDown={handleKeyDown}
          value={search}
        />
      </div>
    </div>
  );
};

export default SearchTable;
